import find from 'lodash.find'


const clientTypes = ['Client', 'Personal', 'School']

const getRandomClientType = (i)=> {
  return clientTypes[i%3]
}

const projects = Array(4).fill().map((_, i)=>({
  id: `project-${i}`,
  title: `Project title ${i}`,
  thumb:  `/images/project${i}.jpg`,
  cover:  `/images/project${i}.jpg`,
  date:  `201${i}`,
  client: getRandomClientType(i),
}))

export default {
  projects: {
    all: () => projects,
    get: id => find(projects, project=> project.id === id)
  }
}



/** WEBPACK FOOTER **
 ** ./src/api.js
 **/